import { motion } from 'framer-motion';
import { GooglePreview, MetaPreview, CampaignDetails } from 'components';
import { useState } from 'react';

const CampaignPreviewSection = ({
  campaignPreview,
  deviceView,
  onGoogleValidationChange
}) => {
  const [_isGoogleValid, setIsGoogleValid] = useState(true);

  if (!campaignPreview?.name || !campaignPreview?.provider) {
    return null;
  }

  const isGoogleCampaign = campaignPreview.provider.toLowerCase().includes('google');

  const isCampaignSent = Boolean(campaignPreview.provider_campaign_id);

  const handleGoogleValidationChange = (isValid) => {
    setIsGoogleValid(isValid);
    if (onGoogleValidationChange) {
      onGoogleValidationChange(isValid);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className={`transition-all duration-300 ${deviceView === 'mobile' ? 'max-w-lg' : 'max-w-2xl'
        } mx-auto`}
    >
      {isGoogleCampaign && <CampaignDetails campaignPreview={campaignPreview} />}

      {isGoogleCampaign ? (
        <GooglePreview 
          campaignPreview={campaignPreview} 
          isCampaignSent={isCampaignSent}
          onValidationChange={handleGoogleValidationChange}
        />
      ) : (
        <MetaPreview
          campaignPreview={campaignPreview}
          isCampaignSent={isCampaignSent}
        />
      )}
    </motion.div>
  );
};

export default CampaignPreviewSection;